import React from 'react';
import { Box } from '@material-ui/core';
import { Theme } from '@orijinworks/frontend-commons';
import DeleteModal from '../../../../../../shared/components/DeleteModal/DeleteModal';
import ExportPlanModal from '../../../../components/export-plan-modal';
import { CasePlanDetailHeader } from '../CasePlanDetailHeader';
import { CasePlanDetailsSections } from '../CasePlanDetailsSections';

export function CasePlanDetailsContent({
  classes,
  cardProps,
  isViewOnly = false,
  isSectionsLoading,
  collapsedSections,
  onBack,
  onToggleCollapse,
  onAddWidget,
  onWidgetDescriptionBlur,
  onEditorsClick,
  onExportClick,
  isExportOpen,
  onExportClose,
  onExportSubmit,
  status,
  isEditor,
  onStatusSelect,
  pendingStatus,
  onStatusConfirm,
  onStatusCancel,
  sectionApi = {},
}) {
  const { activeSections = [], sectionConfirmation } = sectionApi;

  return (
    <Theme>
      <Box className={classes.page} role="main" aria-label="Case Plan Details">
        <CasePlanDetailHeader
          cardProps={cardProps}
          isSectionsLoading={isSectionsLoading}
          onBack={onBack}
          onEditorsClick={isViewOnly ? undefined : onEditorsClick}
          onExportClick={onExportClick}
          status={status}
          isEditor={isEditor}
          isViewOnly={isViewOnly}
          onStatusSelect={onStatusSelect}
          pendingStatus={pendingStatus}
          onStatusConfirm={onStatusConfirm}
          onStatusCancel={onStatusCancel}
        />
        <CasePlanDetailsSections
          isSectionsLoading={isSectionsLoading}
          collapsedSections={collapsedSections}
          onToggleCollapse={onToggleCollapse}
          onAddWidget={onAddWidget}
          onWidgetDescriptionBlur={isViewOnly ? undefined : onWidgetDescriptionBlur}
          sectionApi={sectionApi}
        />
        {/* Archived sections are excluded: an export must only carry the live plan. */}
        <ExportPlanModal
          open={isExportOpen}
          sections={activeSections}
          onClose={onExportClose}
          onExport={onExportSubmit}
        />
        {sectionConfirmation?.isOpen && (
          <DeleteModal
            open
            status={sectionConfirmation.modalStatus}
            title={sectionConfirmation.title}
            description={sectionConfirmation.description}
            onClose={sectionConfirmation.onCancel}
            onContinue={sectionConfirmation.onConfirm}
          />
        )}
      </Box>
    </Theme>
  );
}
